export const architecture_urban = [
  { char: '🏙️', name: 'Cityscape', nameZh: '都市天際線', keywords: ['city', 'view', 'night'], hot: true },
  { char: '🏢', name: 'Office Building', nameZh: '商辦大樓', keywords: ['work', 'business', 'city'] },
  { char: '🏫', name: 'School', nameZh: '校園建築', keywords: ['learn', 'education', 'study'] },
  { char: '🏛️', name: 'Classical Building', nameZh: '博物館/歷史', keywords: ['museum', 'law', 'history'] },
  { char: '🏗️', name: 'Construction', nameZh: '建設中', keywords: ['build', 'work', 'crane'], hot: true },
  { char: '🧱', name: 'Brick', nameZh: '基礎建築', keywords: ['wall', 'base', 'solid'] },
  { char: '🏘️', name: 'Houses', nameZh: '住宅社區', keywords: ['home', 'neighborhood', 'living'] },
  { char: '🗼', name: 'Tokyo Tower', nameZh: '城市地標', keywords: ['landmark', 'japan', 'travel'] },
  { char: '🏰', name: 'Castle', nameZh: '經典建築', keywords: ['history', 'europe', 'old'] },
  { char: '🪟', name: 'Window', nameZh: '採光/視野', keywords: ['view', 'look', 'glass'] },
  { char: '🛗', name: 'Elevator', nameZh: '電梯/升遷', keywords: ['up', 'down', 'move'] },
  { char: '🏚️', name: 'Derelict House', nameZh: '廢墟/改建', keywords: ['old', 'broken', 'history'] },
];